export enum LanguageSpeakDatesAs {
  dayMonthYear = 'dmy',
  monthDayYear = 'mdy',
  yearMonthDay = 'ymd'
}
